import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { cloneDeep } from 'lodash-es';
import { updateVerbaleOnStore } from '@core/helpers/create-validator.helper';
import { withChangeDebounced } from '@shared/operators/with-change-debounced.operator';
import { MyVerbale } from '../../../models/interfaces/revisione.interface';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { getSchedaPrevalenzaControl } from '../validators/helpers/natura-mutualistica-form-validators.helper';

export const setNatMutSchedaValoriListeners = (form: FormGroup, store: Store<Revisione53State>): void => {
    my_TotaleA1(form, store);
    my_TotaleA1PrimoAnno(form, store);
    my_TotaleB9(form, store);
    my_TotaleB9PrimoAnno(form, store);
    my_TotaleB6(form, store);
    my_TotaleB6PrimoAnno(form, store);
    my_TotaleB7(form, store);
    my_TotaleB7PrimoAnno(form, store);
    my_B6confSociPrimoAnno(form, store);
    my_B7ricevSociPrimoAnno(form, store);
    my_B9versoSociPrimoAnno(form, store);
    my_TotQtaConfSoci(form, store);
    my_TotQtaConfSociPrimoAnno(form, store);
    my_QtaConfSociPrimoAnno(form, store);
};

const my_TotaleA1 = (form: FormGroup, store: Store<Revisione53State>): void => {
    setupSchedaValoreSync(form, store, 'my_TotaleA1');
};

const my_TotaleA1PrimoAnno = (form: FormGroup, store: Store<Revisione53State>): void => {
    setupSchedaValoreSync(form, store, 'my_TotaleA1PrimoAnno');
};

const my_TotaleB9 = (form: FormGroup, store: Store<Revisione53State>): void => {
    setupSchedaValoreSync(form, store, 'my_TotaleB9');
};

const my_TotaleB9PrimoAnno = (form: FormGroup, store: Store<Revisione53State>): void => {
    setupSchedaValoreSync(form, store, 'my_TotaleB9PrimoAnno');
};

const my_TotaleB6 = (form: FormGroup, store: Store<Revisione53State>): void => {
    setupSchedaValoreSync(form, store, 'my_TotaleB6');
};

const my_TotaleB6PrimoAnno = (form: FormGroup, store: Store<Revisione53State>): void => {
    setupSchedaValoreSync(form, store, 'my_TotaleB6PrimoAnno');
};

const my_TotaleB7 = (form: FormGroup, store: Store<Revisione53State>): void => {
    setupSchedaValoreSync(form, store, 'my_TotaleB7');
};

const my_TotaleB7PrimoAnno = (form: FormGroup, store: Store<Revisione53State>): void => {
    setupSchedaValoreSync(form, store, 'my_TotaleB7PrimoAnno');
};

const my_B6confSociPrimoAnno = (form: FormGroup, store: Store<Revisione53State>): void => {
    setupSchedaValoreSync(form, store, 'my_B6confSociPrimoAnno');
};

const my_B7ricevSociPrimoAnno = (form: FormGroup, store: Store<Revisione53State>): void => {
    setupSchedaValoreSync(form, store, 'my_B7ricevSociPrimoAnno');
};

const my_B9versoSociPrimoAnno = (form: FormGroup, store: Store<Revisione53State>): void => {
    setupSchedaValoreSync(form, store, 'my_B9versoSociPrimoAnno');
};

const my_TotQtaConfSoci = (form: FormGroup, store: Store<Revisione53State>): void => {
    setupSchedaValoreSync(form, store, 'my_TotQtaConfSoci');
};

const my_TotQtaConfSociPrimoAnno = (form: FormGroup, store: Store<Revisione53State>): void => {
    setupSchedaValoreSync(form, store, 'my_TotQtaConfSociPrimoAnno');
};

const my_QtaConfSociPrimoAnno = (form: FormGroup, store: Store<Revisione53State>): void => {
    setupSchedaValoreSync(form, store, 'my_QtaConfSociPrimoAnno');
};

/**
 * Sincronizza il valore del campo della scheda prevalenza sullo store. L'incoerenza rispetto
 * alla checkbox "prevede di..." è validata, senza cancellare il dato, da schedaPrevalenzaValuesHelper
 * nei rispettivi *.rules.ts (fedele a InfoPath, che non cancella mai il valore inserito).
 */
const setupSchedaValoreSync = (form: FormGroup, store: Store<Revisione53State>, controlPath: string): void => {
    const control = getSchedaPrevalenzaControl(form, controlPath);

    control.valueChanges.pipe(withChangeDebounced(control)).subscribe(() => {
        updateVerbaleOnStore(store, (myVerbale) => {
            const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
            myVerbaleClone.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza[controlPath] = control.value;
            return myVerbaleClone;
        });
    });
};
